module.exports = __webpack_public_path__ + "static/media/cmt_icon2.a89fc870.png";